<template>
    <footer class="page-footer" role="contentinfo">
        <div class="d-flex align-items-center flex-1 text-muted">
            <span class="hidden-md-down fw-700">2018 - {{ $moment().format('YYYY') }} © Edutalk Technology by&nbsp;<a href="https://edutalk.edu.vn" class="text-primary fw-500" title="edutalk.edu.vn" target="_blank">edutalk.edu.vn</a></span>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "edutalk-footer"
    }
</script>
